import React from "react";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import SalaireSimulator from "@/components/SalaireSimulator";

export default function ChefSimulateur() {
  return (
    <div className="min-h-full">
      <PageHeader eyebrow="Outils" title="Simulateur de salaire" sub="Estimez le net (brut → net) et le coût employeur pour vos futurs salariés." />
      <div className="p-6 lg:p-10">
        <SalaireSimulator defaultBrut={2500} />
      </div>
    </div>
  );
}
